var googletag=window.googletag=window.googletag||{};
googletag.cmd=googletag.cmd||[];
var gptEventTracking=(function(){
	var gptRequestTimes={};
	var gptRequestGUID={};
	var gptRenderEndedEvents={};

	var generateGUID=function(){function s4(){return Math.floor((1+Math.random())*0x10000).toString(16).substring(1);}
	return s4()+s4()+'-'+s4()+'-'+s4()+'-'+s4()+'-'+s4()+s4()+s4();
	}

	var getSafe=function(fn, defaultVal) {
		try {
			return fn();
		} catch (e) {
			return defaultVal;
		}
	};

	var commonGPTEventHandler=function(event){
		var slot=event.slot;
		var gtp=googletag.pubads();
		ga('set','dimension30',slot.getAdUnitPath());
		ga('set','dimension31',slot.getSlotElementId());
		ga('set','dimension32',gtp.getTargeting('amp').toString());
		ga('set','dimension33',gtp.getTargeting('article').toString());
		ga('set','dimension34',gtp.getTargeting('article-type').toString());
		ga('set','dimension35',gtp.getTargeting('category').toString());
		ga('set','dimension36',gtp.getTargeting('make').toString());
		ga('set','dimension37',gtp.getTargeting('model').toString());
		ga('set','dimension38',gtp.getTargeting('edition').toString());
		ga('set','dimension39',gtp.getTargeting('page-type').toString());
		ga('set','dimension40',gtp.getTargeting('primary-category').toString());
		ga('set','dimension41',gtp.getTargeting('template').toString());
		ga('set','dimension42',gtp.getTargeting('zone').toString());
		ga('set','dimension43',gtp.getTargeting('main-purpose').toString());
		ga('set','dimension44',gtp.getTargeting('native').toString());
		ga('set','dimension45',gtp.getTargeting('campaign').toString());
    ga('set','dimension46',slot.getTargeting('position').toString());
    ga('set','dimension108',gtp.getTargeting('pageview-guid').toString());
	}
	var commonGPTSlotEventHandler=function(event){
		ga('set','dimension22',getSafe(() => event.advertiserId.toString(), '(not set)'));
		ga('set','dimension23',getSafe(() => event.campaignId.toString(), '(not set)'));
		ga('set','dimension24',getSafe(() => event.creativeId.toString(), '(not set)'));
		ga('set','dimension25',getSafe(() => event.isEmpty.toString(), '(not set)'));
		ga('set','dimension26',getSafe(() => event.lineItemId.toString(), '(not set)'));
		ga('set','dimension27',getSafe(() => event.size.toString(), '(not set)'));
		ga('set','dimension28',getSafe(() => event.sourceAgnosticCreativeId.toString(), '(not set)'));
		ga('set','dimension29',getSafe(() => event.sourceAgnosticLineItemId.toString(), '(not set)'));
	}
	var gaSendEvent=function(time,event,action,valid){
		var data={hitType:'event',eventCategory:'Advertisement',eventAction:action,eventLabel:event.slot.getSlotElementId(),nonInteraction:true}
		if(valid)data.eventValue=time;
		ga('send',data);
	}
	var gaSendTiming=function(time,event,action,valid){
		var data={hitType:'timing',timingCategory:'Advertisement',timingVar:action,timingLabel:event.slot.getSlotElementId(),timingValue:time}
		if(valid)ga('send',data);
	}
	var slotRequestedEventHandler=function(event){
		var time=new Date().getTime()-performance.timing.responseStart;
		gptRequestTimes[event.slot.getSlotElementId()]=time;
		var refresh=(event.slot.getSlotElementId() in gptRequestGUID);
		gptRequestGUID[event.slot.getSlotElementId()]=generateGUID();
		commonGPTEventHandler(event);
		ga('set','metric22',1);
		if (refresh){
			// console.log("GPT Event Tracking|Ad slot refreshed|" + event.slot.getSlotElementId() + "|" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()]);
			ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
			gaSendEvent(time,event,'Ad slot refreshed (GPT)',true);
		}
		else {
			// console.log("GPT Event Tracking|Ad slot requested|" + event.slot.getSlotElementId() + "|" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()]);
			ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
			var valid=(time>0&&time<60000);
			gaSendEvent(time,event,'Ad slot requested (GPT)',valid);
		}
		ga('set','metric22',0);
	}
	var slotResponseReceivedEventHandler=function(event){
		var time=(new Date().getTime()-performance.timing.responseStart)-gptRequestTimes[event.slot.getSlotElementId()];
		var valid=(time>0&&time<60000);
		commonGPTEventHandler(event);
		ga('set','metric23',1);
		ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
		// console.log("GPT Event Tracking|Ad slot response received|" + event.slot.getSlotElementId() + "|+" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()]);
		gaSendEvent(time,event,'Ad slot response received (GPT)',valid);
		ga('set','metric23',0);
	}
	var slotRenderEndedHandler=function(event){
		commonGPTEventHandler(event);
		commonGPTSlotEventHandler(event);
		var time=(new Date().getTime()-performance.timing.responseStart)-gptRequestTimes[event.slot.getSlotElementId()];
		var valid=(time>0&&time<60000);
		gptRenderEndedEvents[event.slot.getSlotElementId()]=event; //assumes this will always happen first
		ga('set','metric15',1);
		ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
		gaSendEvent(time,event,'Ad slot render ended (GPT)',valid);
		// console.log("GPT Event Tracking|Ad slot render ended|" + event.slot.getSlotElementId() + "|+" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()] + "|" + getSafe(() => event.advertiserId.toString(), '(not set)') + "|" + getSafe(() => event.isEmpty.toString(), '(not set)'));
		ga('set','metric15',0);
		gaSendTiming(time,event,'Ad slot render ended (GPT)',valid);
	}
	var slotOnloadEventHandler=function(event){ 
		commonGPTEventHandler(event);
		commonGPTSlotEventHandler(gptRenderEndedEvents[event.slot.getSlotElementId()]);
		var time=(new Date().getTime()-performance.timing.responseStart)-gptRequestTimes[event.slot.getSlotElementId()];
		var valid=(time>0&&time<60000);
		ga('set','metric14',1);
		ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
		gaSendEvent(time,event,'Ad slot loaded (GPT)',valid);
		// console.log("GPT Event Tracking|Ad slot on load|" + event.slot.getSlotElementId() + "|+" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()] + "|" + getSafe(() => gptRenderEndedEvents[event.slot.getSlotElementId()].advertiserId.toString(), '(not set)'));
		ga('set','metric14',0);
		gaSendTiming(time,event,'Ad slot loaded (GPT)',valid);
	}
	var impressionViewableEventHandler=function(event){
		commonGPTEventHandler(event);
		commonGPTSlotEventHandler(gptRenderEndedEvents[event.slot.getSlotElementId()]);
		var time=(new Date().getTime()-performance.timing.responseStart)-gptRequestTimes[event.slot.getSlotElementId()];
		ga('set','metric13',1);
		ga('set','dimension73',gptRequestGUID[event.slot.getSlotElementId()]);
		gaSendEvent(time,event,'Ad slot viewable (GPT)',true);
		// console.log("GPT Event Tracking|Ad slot viewable|" + event.slot.getSlotElementId() + "|+" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()] + "|" + getSafe(() => gptRenderEndedEvents[event.slot.getSlotElementId()].advertiserId.toString(), '(not set)'));
		ga('set','metric13',0);
	}
	var slotVisibilityChangedEventHandler=function(event){
		var time=(new Date().getTime()-performance.timing.responseStart)-gptRequestTimes[event.slot.getSlotElementId()];
		// console.log("GPT Event Tracking|Ad slot visibility changed|" + event.slot.getSlotElementId() + "|+" + time + "|" + gptRequestGUID[event.slot.getSlotElementId()] + "|" + getSafe(() => gptRenderEndedEvents[event.slot.getSlotElementId()].advertiserId.toString(), '(not set)'));
	}
	var init=function(){
    // console.log("GPT Event Tracking Investigation");
		googletag.cmd.push(function(){
			googletag.pubads().addEventListener('slotOnload',slotOnloadEventHandler);
			googletag.pubads().addEventListener('slotRenderEnded',slotRenderEndedHandler);
			googletag.pubads().addEventListener('impressionViewable',impressionViewableEventHandler);
			googletag.pubads().addEventListener('slotRequested',slotRequestedEventHandler);
			googletag.pubads().addEventListener('slotResponseReceived',slotResponseReceivedEventHandler);
			//googletag.pubads().addEventListener('slotVisibilityChanged',slotVisibilityChangedEventHandler);  // Generates LOADS of hits
		});
	}
	return{ init:init };
})();
module.exports = gptEventTracking;
